<script>
import InputField from "@/components/input/InputField.vue";
import {reactive} from "vue";
import { helpers, required} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import {api} from "@/modules/api"
import TextareaField from "@/components/input/TextareaField.vue"
import SelectField from "@/components/input/SelectField.vue"

export default {
  name: 'FormProduct',
  components: { SelectField, TextareaField, InputField},
  setup() {
    const dataForm = reactive({
      title: '',
      description: '',
      price: null,
      quantity: null,
      category: null,
      image: null
    });

    const rules = {
      dataForm: {
        title: {required: helpers.withMessage('Ce champs est obligatoire', required)},
        description: { required: helpers.withMessage('Ce champs est obligatoire', required) },
        price: { required: helpers.withMessage('Ce champs est obligatoire', required) },
        quantity: { required: helpers.withMessage('Ce champs est obligatoire', required) },
        category: { required: helpers.withMessage('Ce champs est obligatoire', required) },
        image: { required: helpers.withMessage('Veuillez ajouter une image', required) }
      }
    };

    const v$ = useVuelidate(rules, { dataForm })

    return { dataForm, v$ }
  },
  mounted() {
    this.loadOptions()
  },
  data () {
    return {
      isLoading: false,
      options: {}
    }
  },
  methods: {
    async loadOptions () {
      await api.categories.options().then((response) => {
        this.options = response.map((option) => {
          return {
            value: option.id,
            text: option.Label
          }
        })
      })
    },
    submitData () {
      this.isLoading = true
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.isLoading = false
        return;
      }

      api.products.create(this.dataForm).then((response) => {
        if (response.product.id) {
          const id = response.product.id
          const form = new FormData()
          form.append('image', this.dataForm.image)
          api.products.upload(form, id).then(() => {
            this.emitter.emit('load-data', true)
            this.$emit('closeView')
          }).catch((e) => {
            console.error(e)
          })
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    handleFileUpload(event) {
      this.dataForm.image = event.target.files[0]
    },
  }
}
</script>

<template>
  <div>
    <div class="space-y-4">
      <input-field
          v-model="dataForm.title"
          label="Nom"
          :validation="v$.dataForm.title"
          placeholder="Nom.."
      />
      <textarea-field
          v-model="dataForm.description"
          label="Description"
          placeholder="Entrez une description"
      />
      <input-field
          v-model="dataForm.price"
          type="number"
          label="Prix"
          :validation="v$.dataForm.price"
          placeholder="Prix.."
      />
      <input-field
          v-model="dataForm.quantity"
          label="Quantité"
          type="number"
          :validation="v$.dataForm.quantity"
          placeholder="Quantité.."
      />
      <select-field
          v-model="dataForm.category"
          label="Catégorie"
          :options="options"
      />
      <div>
        <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" for="image">
          Charger image
        </label>
        <input
            class="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
            id="Image"
            type="file"
            @change="handleFileUpload"
        >
      </div>
      <div class="bottom-0 left-0 flex justify-center w-full pb-4 space-x-4 md:px-4 md:absolute">
        <button @click="submitData" data-drawer-dismiss="drawer-create-product-default" aria-controls="drawer-create-product-default" class="text-white w-full justify-center bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
          Valider
        </button>
        <button @click="$emit('closeView')" class="inline-flex w-full justify-center text-gray-500 items-center bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-primary-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">
          <svg aria-hidden="true" class="w-5 h-5 -ml-1 sm:mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>